const ABProcessParticipantCore = require("../../core/process/ABProcessParticipantCore");
module.exports = class ABProcessParticipant extends ABProcessParticipantCore {};
